import React from 'react';
import './HowItWorks.css';

function HowItWorks() {
  const steps = [
    {
      number: '1',
      icon: '🎙️',
      title: 'Open App & Press Record',
      description: 'Simply tap the record button to start'
    },
    {
      number: '2',
      icon: '💬',
      title: 'Speak Naturally',
      description: 'Say "Sharma ji ne 2 samosa aur ek chai liya ₹100 UPI kiya" in your language',
      example: true
    },
    {
      number: '3',
      icon: '🤖',
      title: 'AI Creates Entry Automatically',
      description: 'AI identifies customer, product, price, payment method and creates the entry',
      details: ['Customer: Sharma ji', 'Items: 2 Samosa, 1 Chai', 'Amount: ₹100', 'Payment: UPI']
    },
    {
      number: '4',
      icon: '🔄',
      title: 'Auto-Sync Everywhere',
      description: 'Instantly syncs to Tally, Zoho Books, and your accounting software',
      badges: ['Tally', 'Zoho Books', 'QuickBooks', 'Excel']
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="how-it-works-header">
        <h2>How It Works</h2>
        <p>From your voice to perfect bookkeeping in 4 simple steps</p>
      </div>

      <div className="steps-container">
        {steps.map((step, index) => (
          <div key={index} className="step-card">
            <div className="step-number">{step.number}</div>
            <div className="step-icon">{step.icon}</div>
            <h3>{step.title}</h3>
            <p className="step-description">{step.description}</p>
            
            {step.example && (
              <div className="example-box">
                <span className="example-label">Example:</span>
                <p className="example-text">"{step.description.split('"')[1]}"</p>
              </div>
            )}

            {step.details && (
              <div className="details-box">
                {step.details.map((detail, idx) => (
                  <div key={idx} className="detail-item">
                    ✓ {detail}
                  </div>
                ))}
              </div>
            )}

            {step.badges && (
              <div className="badges-container">
                {step.badges.map((badge, idx) => (
                  <span key={idx} className="integration-badge">{badge}</span>
                ))}
              </div>
            )}

            {index < steps.length - 1 && (
              <div className="step-arrow">→</div>
            )}
          </div>
        ))}
      </div>

      <div className="how-it-works-footer">
        <p className="time-saved">⚡ Average time per entry: <strong>3 seconds</strong> vs traditional 2-3 minutes</p>
      </div>
    </section>
  );
}

export default HowItWorks;

